module.exports = __webpack_public_path__ + "img/FACTORAJEF.93c45fbd.svg";